import {
  SecurityPipelineGithubSpacePage,
  SecurityPipelineGithubSpacePageProps,
} from "~/pages/integrations/security-pipeline/security-pipeline-github/SecurityPipelineGithubSpacePage/SecurityPipelineGithubSpacePage";

const SecurityPipelineGithubSpaceEntryPage = ({
  scope,
}: SecurityPipelineGithubSpacePageProps) => {
  return <SecurityPipelineGithubSpacePage {...{ scope }} />;
};

export default SecurityPipelineGithubSpaceEntryPage;
